export default "__VITE_ASSET__1e2d67a1__"